/**
 * 统一封装 localStorage / sessionStorage 读写，避免各处直接写 window.localStorage / window.sessionStorage。
 * 在非浏览器环境（如 SSR）下安全降级为 no-op。
 */

function getStorage(type) {
  if (typeof window === 'undefined') return null;
  try {
    return type === 'local' ? window.localStorage : window.sessionStorage;
  } catch (e) {
    return null;
  }
}

function getLocal(key) {
  var storage = getStorage('local');
  return storage ? storage.getItem(key) : null;
}

function setLocal(key, value) {
  var storage = getStorage('local');
  if (storage) storage.setItem(key, value);
}

function removeLocal(key) {
  var storage = getStorage('local');
  if (storage) storage.removeItem(key);
}

function getSession(key) {
  var storage = getStorage('session');
  return storage ? storage.getItem(key) : null;
}

function setSession(key, value) {
  var storage = getStorage('session');
  if (storage) storage.setItem(key, value);
}

function removeSession(key) {
  var storage = getStorage('session');
  if (storage) storage.removeItem(key);
}

function getLocalJSON(key, fallback) {
  var raw = getLocal(key);
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
}

export default {
  getLocal: getLocal,
  setLocal: setLocal,
  removeLocal: removeLocal,
  getSession: getSession,
  setSession: setSession,
  removeSession: removeSession,
  getLocalJSON: getLocalJSON
};

